module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('step', {
    attrs: {
      "navItems": _vm.navItems,
      "index": 1,
      "step": _vm.step
    },
    on: {
      "step": _vm.updateStep,
      "back": function () {
        this$1.$router.push('/course-mgr')
      }
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('attachment_list')))])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-8 offset-2"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [(_vm.file === null) ? _c('li', {
    staticClass: "list-group-item border text-left mb-3",
    staticStyle: {
      "line-height": "150%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.$refs.file.click()
      }
    }
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('upload_tips'))), _c('br'), _vm._v("\n                " + _vm._s(_vm.$t('upload_rules')) + "\n              ")])]) : _c('li', {
    staticClass: "list-group-item border text-left mb-3",
    staticStyle: {
      "line-height": "150%"
    }
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n                " + _vm._s(_vm.file.name)), _c('br'), _vm._v(_vm._s(Math.round(_vm.file.size * 1000 / 1024 / 1024) / 1000) + " MB\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('icon-button', {
    attrs: {
      "name": "upload",
      "alt": _vm.$t('upload_progress')
    },
    nativeOn: {
      "click": function($event) {
        _vm.upload()
      }
    }
  })], 1)]), _vm._v(" "), (_vm.progress > -1) ? _c('li', {
    staticClass: "list-group-item text-left mb-3 border-0 clearfix pt-4"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v(_vm._s(_vm.$t('upload_progress')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "progress mt-2",
    staticStyle: {
      "height": "0.2rem"
    }
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger progress-bar-striped active",
    style: ({
      width: _vm.progress + '%',
      'border-width': '1px',
      'background-color': '#5dceb0'
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progress) + "% " + _vm._s(_vm.$t('_finish')))])])]), _vm._v(" "), _c('icon-button', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    },
    attrs: {
      "name": "cancelUpload"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelUpload()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item border text-left mb-3",
      staticStyle: {
        "line-height": "150%"
      }
    }, [_c('div', {
      staticClass: "float-left"
    }, [_vm._v("\n                " + _vm._s(item.name)), _c('br'), _vm._v(_vm._s(Math.round(item.fileSize * 1000 / 1024 / 1024) / 1000) + " MB\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "float-right"
    }, [_c('icon-button', {
      attrs: {
        "name": "download",
        "alt": _vm.$t('_download')
      },
      nativeOn: {
        "click": function($event) {
          _vm.getAttachment(item.id)
        }
      }
    }), _vm._v(" "), _c('icon-button', {
      attrs: {
        "name": "delete",
        "alt": _vm.$('delete')
      },
      nativeOn: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('pagination', {
    staticClass: "mt-3",
    attrs: {
      "current": _vm.pageIndex,
      "total": _vm.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  })], 1)])])], 2), _vm._v(" "), _c('step', {
    attrs: {
      "navItems": _vm.navItems,
      "index": 2,
      "step": _vm.step
    },
    on: {
      "step": _vm.updateStep,
      "finish": function () {
        this$1.$router.push('/course-mgr')
      }
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('_finish')))])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1972d4c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/TeachingCourseAttachment.vue
// module id = 709
// module chunks = 1